import React from "react";
import PokeApp from "./components/PokeApp";

function App() {
  return (
    <div className="App">
      <PokeApp />
    </div>
  );
}

export default App;
